window.BananaMoon = window.BananaMoon || {};

const FAST_TRACK_API = "https://backoffice.banana-moon-clothing.co.uk/api/fast-track";

window.BananaMoon.getFastTrackFactor = async function (multiplier = false) {
    let responseJSON = "";
    try {
        let response = await fetch(FAST_TRACK_API, {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });

        if (!response.ok) {
            let errorMessage = await response.text();

            throw new Error(`Failed to fetch Fast Track details: ${errorMessage} ${response.status}`);
        }

        responseJSON = await response.json();

        if (multiplier)
            return 1 + responseJSON['factor'];
        else
            return responseJSON['factor'];
    } catch (error) {
        console.error("Fetch error: " + error.message);
        throw error;
    }
}